import { GlobalConfigType } from 'actions'
import { useSelector } from 'react-redux'

export const useIsCompanyEmail = (_email: string = '') => {
  const { adminEmailDns, email } = useSelector((state: any) => ({
    adminEmailDns: state.globalConfigReducer[GlobalConfigType.GlobalSettingV2].adminEmailDns,
    email: state.auth.profile.email,
  }))

  const dnsList: string[] = (adminEmailDns || '').split(';')

  return !!dnsList.find((dns) => (_email || email || '').endsWith(`@${dns}`))
}
